export const INIT_SESSION_LIST = 'INIT_SESSION_LIST';
export const ADD_SESSION = 'ADD_SESSION';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const DELETE_SESSION = 'DELETE_SESSION';

export default { INIT_SESSION_LIST, ADD_SESSION, UPDATE_SESSION, DELETE_SESSION };
